import type { FormEvent, KeyboardEvent } from 'react';
import { Button, Stack, TextField } from '@mui/material';
import { Send } from '@mui/icons-material';

export default function MessageComposer({
  value,
  onChange,
  onSend,
  pending,
  unavailable = false,
  helperText,
}: {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  pending: boolean;
  unavailable?: boolean;
  helperText?: string;
}) {
  const send = (event: FormEvent) => {
    event.preventDefault();
    if (!pending && !unavailable && value.trim()) onSend();
  };
  const enter = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) send(event);
  };
  return (
    <Stack component="form" onSubmit={send} spacing={2}>
      <TextField
        label="Message"
        multiline
        minRows={2}
        maxRows={6}
        fullWidth
        value={value}
        disabled={pending || unavailable}
        helperText={helperText || 'Enter to send; Shift+Enter for a new line.'}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={enter}
      />
      <Button
        type="submit"
        variant="contained"
        startIcon={<Send />}
        disabled={pending || unavailable || !value.trim()}
        loading={pending}
        loadingPosition="start"
        sx={{ alignSelf: { xs: 'stretch', sm: 'flex-end' } }}
      >
        {pending ? 'Sending…' : 'Send Message'}
      </Button>
    </Stack>
  );
}
